const TOKEN_KEY = 'kivonex-admin-token';
/**
 * Where the Kivonex Cloud API is. Blank (the default) means this site's own /v1, which the dev server forwards;
 * a production build served on its own address sets REACT_APP_KIVONEX_API (https://backend.kivonex.in).
 */
export const API_BASE = (process.env.REACT_APP_KIVONEX_API ?? '').replace(/\/+$/, '');
export function apiUrl(path) {
    return `${API_BASE}${path}`;
}
export function getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
    sessionStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
    sessionStorage.removeItem(TOKEN_KEY);
}
export async function api(path, init) {
    const headers = new Headers(init?.headers);
    if (init?.body)
        headers.set('Content-Type', 'application/json');
    const token = getToken();
    if (token)
        headers.set('Authorization', `Bearer ${token}`);
    const response = await fetch(apiUrl(path), { ...init, headers });
    const body = (await response.json().catch(() => ({})));
    if (response.status === 401) {
        clearToken();
        window.dispatchEvent(new Event('kivonex-admin-unauthorized'));
    }
    if (!response.ok) {
        throw new Error(body.error?.message ?? 'Request failed');
    }
    return body;
}
/**
 * Puts an installer on this API (never on B2 from the browser). Progress is 0–1.
 * In local ADMIN the CRA proxy can stall on a 150+ MB body, so the file goes to the API host.
 */
export function putInstaller(objectKey, file, onProgress) {
    const path = `/v1/admin/releases/desktop/file?objectKey=${encodeURIComponent(objectKey)}`;
    const url = API_BASE ? `${API_BASE}${path}` : `http://127.0.0.1:8790${path}`;
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url);
        const token = getToken();
        if (token)
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable && onProgress)
                onProgress(event.loaded / event.total);
        };
        xhr.onload = () => {
            let payload = {};
            try {
                payload = JSON.parse(xhr.responseText || '{}');
            }
            catch { /* the API always sends JSON; a proxy HTML page is treated as a generic failure */ }
            if (xhr.status === 401) {
                clearToken();
                window.dispatchEvent(new Event('kivonex-admin-unauthorized'));
            }
            if (xhr.status >= 200 && xhr.status < 300)
                return resolve(payload);
            reject(new Error(payload.error?.message ?? 'The installer could not be uploaded.'));
        };
        xhr.onerror = () => reject(new Error('The installer could not be uploaded.'));
        xhr.send(file);
    });
}
/** Ends this admin session on the server, then forgets it here. */
export async function signOut() {
    await api('/v1/admin/session', { method: 'DELETE' }).catch(() => undefined);
    clearToken();
}
/** Admin sign-in, step 1: a one-time code for the mobile number. */
export function requestSignInCode(mobile) {
    return api('/v1/admin/session/code', { method: 'POST', body: JSON.stringify({ mobile }) });
}
/** Admin sign-in, step 2: the mobile number and its code. */
export function signIn(mobile, code) {
    return api('/v1/admin/session', { method: 'POST', body: JSON.stringify({ mobile, code }) });
}
/** A mobile number as shown: +91 73640 76458. */
export function showMobile(mobile) {
    return mobile.length === 10 ? `+91 ${mobile.slice(0, 5)} ${mobile.slice(5)}` : mobile;
}
